export default __webpack_public_path__ + "static/media/pumpkin1.4fdf4639.png";